import BaseServiceHttp from '../baseService'
class Postagens extends BaseServiceHttp {
  constructor(id) {
    const resource = 'postagens'
    const relationship = {
      video: 'video',
      destroyPostagemPlagio: 'destroy-postagem-plagio'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Postagens(id)
